import { useNavigate } from 'react-router-dom';
import { Users, BarChart3, Lightbulb, Shield, User, Moon, Download } from 'lucide-react';
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from '@/components/ui/command';
import { useUIStore } from '@/stores/uiStore';
import { useMembers } from '@/hooks/useMembers';
import { AvatarCircle } from '@/components/members/AvatarCircle';

export function CommandPalette() {
  const navigate = useNavigate();
  const commandOpen = useUIStore((s) => s.commandOpen);
  const setCommandOpen = useUIStore((s) => s.setCommandOpen);
  const toggleTheme = useUIStore((s) => s.toggleTheme);
  const { data: members } = useMembers();

  const runAction = (action: () => void) => {
    setCommandOpen(false);
    action();
  };

  return (
    <CommandDialog open={commandOpen} onOpenChange={setCommandOpen}>
      <CommandInput placeholder="Type a command or search members..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>

        {members && members.length > 0 && (
          <CommandGroup heading="Members">
            {members.slice(0, 10).map((member) => (
              <CommandItem
                key={member.Name}
                value={member.Name}
                onSelect={() => runAction(() => navigate('/members'))}
              >
                <AvatarCircle name={member.Name} size="sm" />
                <span>{member.Name}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}

        <CommandSeparator />

        <CommandGroup heading="Navigation">
          <CommandItem onSelect={() => runAction(() => navigate('/members'))}>
            <Users className="h-4 w-4" />
            Members
          </CommandItem>
          <CommandItem onSelect={() => runAction(() => navigate('/charts'))}>
            <BarChart3 className="h-4 w-4" />
            Charts
          </CommandItem>
          <CommandItem onSelect={() => runAction(() => navigate('/insights'))}>
            <Lightbulb className="h-4 w-4" />
            Insights
          </CommandItem>
          <CommandItem onSelect={() => runAction(() => navigate('/admin'))}>
            <Shield className="h-4 w-4" />
            Admin
          </CommandItem>
          <CommandItem onSelect={() => runAction(() => navigate('/profile'))}>
            <User className="h-4 w-4" />
            My Profile
          </CommandItem>
        </CommandGroup>

        <CommandSeparator />

        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => runAction(toggleTheme)}>
            <Moon className="h-4 w-4" />
            Toggle theme
          </CommandItem>
          <CommandItem
            onSelect={() =>
              runAction(() => {
                const blob = new Blob(
                  [JSON.stringify(members ?? [], null, 2)],
                  { type: 'application/json' },
                );
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'contacts.json';
                a.click();
                URL.revokeObjectURL(url);
              })
            }
          >
            <Download className="h-4 w-4" />
            Export contacts
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
